import { defineComponent, ref } from 'vue'
import ru from 'yup-locale-ru'
import { host } from '@/const'
import axios from '@/axios'
import * as yup from 'yup'
import { useField, useFieldArray, useForm, FieldArray, Field, ErrorMessage } from 'vee-validate'
import './style.sass'
import Preloader from '@/components/preloader/preloader.vue'
import PersonalDataCheckbox from "@/components/personal-data-checkbox";

export default defineComponent({
  props: {
    updateData: {
      type: Function,
      default: (value: boolean) => value
    },
    noEdit: {
      type: Function,
      default: (value: boolean) => value
    },
    typeData: {
      type: String,
      default: () => ''
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  setup (props) {
    yup.setLocale(ru)

    const endpoint = ref('/api/v1/client/update')
    const preloader = ref(false)
    const arrayPhones = ref([])
    const arrayEmails = ref([])
    const isNotChange = ref(false)
    const sendMessageSuccess = ref('')
    const sendMessageError = ref('')

    // Personal
    const schemaPersonal = yup.object().shape(
      {
        firstName: yup.string().required(),
        secondName: yup.string().required(),
        lastName: yup.string().required(),
        personalData: yup.boolean()
          // @ts-ignore
          .oneOf([true], "Вы не дали согласие")
          .test("only-yes", "Вы не дали согласие", value => value === true)
      }
    )

    type FormInputsPersonal = {
      firstName: string,
      secondName: string,
      lastName: string,
      personalData: boolean
    }

    // @ts-ignore
    const { handleSubmit: handlePersonal } = useForm<FormInputsPersonal>({ validationSchema: schemaPersonal })

    const { value: firstName, errorMessage: firstNameError } = useField<string | undefined>('firstName', undefined, { initialValue: props.data.firstName })
    const { value: secondName, errorMessage: secondNameError } = useField<string | undefined>('secondName', undefined, { initialValue: props.data.secondName })
    const { value: lastName, errorMessage: lastNameError } = useField<string | undefined>('lastName', undefined, { initialValue: props.data.lastName })
    const { value: personalData, errorMessage: personalError } = useField<boolean | undefined>('personalData')
    personalData.value = false

    const mindBoxUUid = getCookie() 
    
    const onSubmitPersonal = handlePersonal(async (data) => {
      const currentPersonal = {
        firstName: props.data.firstName,
        secondName: props.data.secondName,
        lastName: props.data.lastName
      }
      // @ts-ignore
      isNotChange.value = JSON.stringify(data) === JSON.stringify(currentPersonal)

      sendMessageSuccess.value = ''
      sendMessageError.value = ''

      if (!isNotChange.value) {
        preloader.value = true
        let response = null

        try {
          response = (await axios.post(`${host}${endpoint.value}`, data)).data
          if (response.message) {
            if (response.success != false) {
              sendMessageSuccess.value = response.message
              isNotChange.value = false
              props.updateData()
              props.noEdit(false)
            } else {
              sendMessageError.value = response.message
            } 
          } else {
            sendMessageError.value = 'Произошла ошибка, попробуйте позже'
          }
          preloader.value = false
        } catch (error: unknown | Record<string, string>) {
          preloader.value = false
          sendMessageError.value = 'Произошла ошибка, попробуйте позже'
        }
      }
    })
    // End Personal

    // Credentials
    const schemaCredentials = yup.object().shape({
      phones: yup
        .array()
        .of(
          yup.object().shape({
            phone: yup.string().length(18).required()
          })
        )
        .strict(),
      emails: yup
        .array()
        .of(
          yup.object().shape({
            email: yup.string().email().required()
          })
        )
        .strict(),
      personalDataCredentials: yup.boolean()
        // @ts-ignore
        .oneOf([true], "Вы не дали согласие")
        .test("only-yes", "Вы не дали согласие", value => value === true)
    })

    type FormInputsCredentials = {
      emails: Array<string>,
      phones: Array<string>,
      personalDataCredentials: boolean
    }

    // @ts-ignore
    const { handleSubmit: handleCredentials } = useForm<FormInputsCredentials>({ validationSchema: schemaCredentials })

    const { push: setPhones, fields: phones } = useFieldArray<unknown>('phones')
    const { push: setEmails, fields: emails } = useFieldArray<unknown>('emails')
    const { value: personalDataCredentials, errorMessage: personalCredentialsError } = useField<boolean | undefined>('personalDataCredentials')
    personalDataCredentials.value = true

    if (props.typeData === 'credentials') {
      arrayPhones.value = props.data.clientPhones.map((item?: unknown) => {
        setPhones(item)
      })

      arrayEmails.value = props.data.clientEmails.map((item?: unknown) => {
        setEmails(item)
      })
    }

    const onSubmitCredentials = handleCredentials(async (data) => {
      let isPhonesChange: boolean = false
      let isEmailsChange: boolean = false

      // очищаем номера от маски и сравниваем номера
      if (data.phones.length > 0) {
        data.phones.map((item, idx) => {
          // @ts-ignore
          data.phones[idx].phone = Number(data.phones[idx].phone.replace(/[^0-9]/g, ''))
 
          if (props.data.clientPhones[idx] === undefined) {
            isPhonesChange = true
          }
          // @ts-ignore
          else if (data.phones[idx].phone !== props.data.clientPhones[idx].phone) {
            isPhonesChange = true
          }
        })
      }

      if (data.emails.length > 0) {
        data.emails.map((item, idx) => {
          // @ts-ignore
          if (props.data.clientEmails[idx] === undefined) {
            isEmailsChange = true;
          }
          // @ts-ignore
          else if (data.emails[idx].email !== props.data.clientEmails[idx].email) {
            isEmailsChange = true
          }
        })
      }

      isNotChange.value = !(isPhonesChange || isEmailsChange)

      sendMessageSuccess.value = ''
      sendMessageError.value = ''

      if (!isNotChange.value) {
        preloader.value = true
        let response = null

        try {
          response = (await axios.post(`${host}${endpoint.value}`, data)).data
          if (response.message) {
            if (response.success != false) {
              sendMessageSuccess.value = response.message
              isNotChange.value = false
              props.updateData()
              props.noEdit(false)
            } else {
              sendMessageError.value = response.message
            } 
          } else {
            sendMessageError.value = 'Произошла ошибка, попробуйте позже'
          }
          preloader.value = false
        } catch (error: unknown | Record<string, string>) {
          preloader.value = false
          sendMessageError.value = 'Произошла ошибка, попробуйте позже'
        }
      }
    })
    // End Credentials

    function closeModal ($event: MouseEvent) {
      // @ts-ignore
      if ($event?.target?.classList.value === 'close' || $event?.target?.classList.value === 'overlay') {
        props.noEdit(false)
      }
    }

    function cancelIsNotChange () {
      isNotChange.value = false
    }

    function getCookie() {
      var name = "mindboxDeviceUUID" + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }


    return () => (
      <div class="overlay" onClick={($event) => closeModal($event)}>
        <div class="change-data-modal">
          <a class="close" onClick={($event) => closeModal($event)} />
          <p>Изменить данные</p>
          {props.typeData === 'personal'
            ? (
              <form onSubmit={values => onSubmitPersonal(values)}>
                <div class="inputs">
                  <div class="input">
                    <input onInput={() => cancelIsNotChange()} v-focus placeholder="Фамилия" v-model={lastName.value}/>
                    <span class="error-message">{lastNameError.value}</span>
                  </div>
                  <div class="input">
                    <input onInput={() => cancelIsNotChange()} placeholder="Имя" v-model={firstName.value}/>
                    <span class="error-message">{firstNameError.value}</span>
                  </div>
                  <div class="input">
                    <input onInput={() => cancelIsNotChange()} placeholder="Отчество" v-model={secondName.value}/>
                    <span class="error-message">{secondNameError.value}</span>
                  </div>
                </div>
                <PersonalDataCheckbox personalData={personalData} personalError={personalError} />
                <div class="button-block">
                  {preloader.value
                    ? (<Preloader style="position: relative; margin: 30px 29px 29px 75px; top: 3px;"/>)
                    : (<button>Изменить</button>)
                  }
                  {isNotChange.value
                    ? (<span class="error-message" style="margin-left: 25px;">Нет изменений</span>)
                    : null
                  }
                  {sendMessageError.value
                    ? (<span class="error-message" style="margin-left: 25px;">{ sendMessageError.value }</span>)
                    : null
                  }
                  {sendMessageSuccess.value
                    ? (<span class="success-message" style="margin-left: 25px;">{ sendMessageSuccess.value }</span>)
                    : null
                  }
                </div>
              </form>
            ) : null
          }
          {props.typeData === 'credentials'
            ? (
              <form onSubmit={values => onSubmitCredentials(values)}>
                <div class="inputs">
                  {phones.value.length
                    ? (
                      <div class="phones">
                        <FieldArray name="phones">
                          {phones.value.map((item, index) => (
                            <div class="input">
                              <Field
                                v-maska={'+7 (###) ###-##-##'}
                                name={`phones[${index}].phone`}
                              />
                              <ErrorMessage name={`phones[${index}].phone`}/>
                            </div>
                          ))}
                        </FieldArray>
                      </div>
                    ) : <div class="phones">
                          <FieldArray name="phones">
                              <div class="input">
                                <Field
                                  v-maska={'+7 (###) ###-##-##'}
                                  name={`phones[0].phone`}
                                />
                                <ErrorMessage name={`phones[0].phone`}/>
                              </div>
                          </FieldArray>
                        </div>
                  }
                  {emails.value.length
                    ? (
                      <div class="emails">
                        <FieldArray name="emails">
                          {emails.value.map((item, index) => (
                            <div class="input">
                              <Field
                                name={`emails[${index}].email`}
                              />
                              <ErrorMessage name={`emails[${index}].email`} />
                            </div>
                          ))}
                        </FieldArray>
                      </div>
                    ) : <div class="emails">
                          <FieldArray name="emails">
                              <div class="input">
                                <Field
                                  name={`emails[0].email`}
                                />
                                <ErrorMessage name={`emails[0].email`} />
                              </div>
                          </FieldArray>
                        </div>
                      }
                </div>
                <PersonalDataCheckbox personalData={personalDataCredentials} personalError={personalCredentialsError} />
                <div class="button-block">
                  {preloader.value
                    ? (<Preloader style="position: relative; margin: 30px 29px 29px 75px; top: 3px;"/>)
                    : (<button>Изменить</button>)
                  }
                  {isNotChange.value
                    ? (<span class="error-message" style="margin-left: 25px;">Нет изменений</span>)
                    : null
                  }
                  {sendMessageError.value
                    ? (<span class="error-message" style="margin-left: 25px;">{ sendMessageError.value }</span>)
                    : null
                  }
                  {sendMessageSuccess.value
                    ? (<span class="success-message" style="margin-left: 25px;">{ sendMessageSuccess.value }</span>)
                    : null
                  }
                </div>
              </form>
            ) : null
          }
        </div>
      </div>
    )
  }
})